/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import { Typography } from '@mui/material';
import { formatDate } from '@/utils/constants';
import { safelyParseDate } from '@/utils/date';

const DebtorEffectiveDate = ({ PolicyEffectiveDate }) => {
	const effectiveDate = safelyParseDate(PolicyEffectiveDate);

	return <Typography>{formatDate(effectiveDate, false)}</Typography>;
};

export default DebtorEffectiveDate;
